<template>
    <div>
        <app-sub-title text="Historial de cambios" />
        <app-form-select-input
            v-if="!isVigilance && !isClientAdmin" 
            label="Cliente"
            :options="clients"
            v-model="clientId"
            @change="onChangeClient"
        />
        <app-shifts-history-filters @filter="onFilter" />
        <app-paginator
            v-if="data"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        />
        <div class="d-flex">
            <div class="w-25" v-for="shift in data.data" :key="shift.id">
                <app-shift-history-card :shift="shift" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import shiftRepository from '../../../repositories/shifts.repository.js'
import ShiftHistoryCard from './ShiftHistoryCard/ShiftHistoryCard.vue'
import ShiftsHistoryFilters from './ShiftsHistoryFilters/ShiftsHistoryFilters.vue'
import Paginator from '../../UI/Controls/Paginator/Paginator.vue'
export default {
    components: {
        appShiftHistoryCard: ShiftHistoryCard,
        appShiftsHistoryFilters: ShiftsHistoryFilters,
        appPaginator: Paginator,
    },

    data() {
        return {
            page: 1,
            filters: null,
            clientId: '',
            isVigilance: false,
            data: '',
        }
    },

    methods: {
        onChangeClient() {
            this.page = 1
            this.filters = null
            this.loadShiftsToolStatuses()
        },
        loadShiftsToolStatuses() {
            const sr = { ...shiftRepository }
            const filters = {
                ...this.filters,
                client: this.clientId,
                with: 'shiftToolStatuses.user.profile',
            }
            sr.getShiftsToolStatuses(filters, this.page)
                .then(data => {
                    this.data = data
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar el estado de las herramientas'
                    )
                )
        },
        onChangePage(page) {
            this.page = page
            this.loadShiftsToolStatuses()
        },
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadShiftsToolStatuses()
        },
    },
    computed: {
        ...mapGetters(['clients', 'client']),
        isClientAdmin() {
            return this.user.profile.slug === 'cliente-admin' || 
                   this.user.profile.client_side === true;
        },
    },
    created() {
        this.load('clients')
        this.isVigilance = this.user.profile.slug === 'vigilante' ? true : false
        
        if (this.client && (this.isVigilance || this.isClientAdmin)) {
            this.clientId = this.client.id
            this.loadShiftsToolStatuses()
        }
    },
}
</script>

<style>
</style>
